import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
import { OptionDescription } from 'owa-options-controls';
import strings from 'owa-strings/owa-options-strings';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import getStore from '../store/store';
import requestMailboxExport from '../actions/requestMailboxExport';
import ExportMailboxStatus from '../components/ExportMailboxStatus';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';
var styles = require('./ExportMailbox.scss');
var ExportMailbox = /** @class */ (function (_super) {
    tslib_1.__extends(ExportMailbox, _super);
    function ExportMailbox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExportMailbox.prototype.render = function () {
        var _a = getStore(), isExportMailboxRequestMade = _a.isExportMailboxRequestMade, downloadLink = _a.downloadLink;
        return (React.createElement("div", null,
            React.createElement(OptionDescription, null, strings.option_description_1_export_mailbox),
            React.createElement(OptionDescription, null, strings.option_description_2_export_mailbox),
            React.createElement("div", { className: styles.buttonStatusLine },
                React.createElement(PrimaryButton, { text: strings.option_export_mailbox_button_label, disabled: isExportMailboxRequestMade !== false && !downloadLink, onClick: requestMailboxExport }),
                isExportMailboxRequestMade === undefined ? (React.createElement(Spinner, null)) : (React.createElement(ExportMailboxStatus, null)))));
    };
    ExportMailbox = tslib_1.__decorate([
        observer
    ], ExportMailbox);
    return ExportMailbox;
}(React.Component));
export default ExportMailbox;
//# sourceMappingURL=ExportMailbox.js.map